module.exports = __webpack_public_path__ + "static/media/frontend_bg_shaded_compressed.fdc74417.jpg";